export default function AuthorizedFunction(roles) {
  const isAutherized = () => {
    if (roles) {
      return true;
    }
    return false;
  };

  return isAutherized();
}
